export default class CaseDetail {
    case_detail_id: string;
    client_reference_id: string | undefined;
    field_name: string; 
    field_value: string;
    created_date: string;
    created_by: string;
    updated_date: string;
    updated_by: string;
    field_type: string;
    field_value_type: string;

    constructor(
        case_detail_id: string,
        client_reference_id: string | undefined,
        field_name: string, 
        field_value: string,
        created_date: string,
        created_by: string,
        updated_date: string,
        updated_by: string,
        field_type: string,
        field_value_type: string,
    ) {
        this.case_detail_id = case_detail_id;
        this.client_reference_id = client_reference_id;
        this.field_name = field_name 
        this.field_value = field_value;
        this.created_date = created_date;
        this.created_by = created_by;
        this.updated_date = updated_date;
        this.updated_by = updated_by;
        this.field_type = field_type;
        this.field_value_type = field_value_type;
    }

    public static initialiseCaseDetail(responses: any): CaseDetail[] {
        let records: CaseDetail[] = responses.map((record: any) => {
            return new CaseDetail(
                record.case_detail.case_detail_id,
                record.case_detail.client_reference_id,
                record.field.field_name,
                record.case_detail.field_value,
                record.case_detail.created_date,
                record.case_detail.created_by,
                record.case_detail.updated_date,
                record.case_detail.updated_by,
                record.field.field_type,
                record.field.field_value_type
            );
        });
        records.sort((a, b) => a.field_name.localeCompare(b.field_name));
        return records;
    }
}